import { render, staticRenderFns } from "./editRecords.vue?vue&type=template&id=3eee48ce"
import script from "./editRecords.vue?vue&type=script&lang=js"
export * from "./editRecords.vue?vue&type=script&lang=js"
import style0 from "./editRecords.vue?vue&type=style&index=0&id=3eee48ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports